import { Vue, Prop, Watch, Component } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import baseAPIService from '@/services/base/baseAPIService';

@Component({})
export default class SiteStockConfig extends Vue {
  /**
   * 库存类型列表
   * @type {Array<ItemObject>}
   */
  public stockTypeList = [
    { label: 0, text: '小程序默认库存' },
    { label: 1, text: '可提库存' },
    { label: 2, text: '可售库存' },
  ];

  /**
   * 可提/可售
   * @type {number}
   */
  public stockType = 1;

  /**
   * 之前选择的值
   * @type {number}
   */
  public historyData = 1;

  /**
   * 商品货号
   * @type {string}
   */
  public productCodes = '';

  /**
   * 运营模式
   * @type {number}
   */
  public mode = 0;

  /**
   * 网点组Id
   * @type {number}
   */
  public sgId = 0;

  /**
   * 是否开启定制功能
   * @type {boolean}
   */
  public isCustomEnabled = false;

  /**
   * 上一次保存成功的定制功能状态
   * @type {boolean}
   */
  public historyCustomEnabled = false;

  /**
   * 定制功能价格
   * @type {number}
   */
  public customizePrice: number | null = null;

  /**
   * 上一次保存成功的定制功能价格
   * @type {number}
   */
  public historyCustomizePrice: number | null = null;

  /**
   * 定制功能保存中
   * @type {boolean}
   */
  public isCustomizeSaving = false;

	public corpId = baseAPIService.resolveCorpId();

  public customizeCorpIds = ['really', 'test_really'];

  get isCustomizeVisible() {
    return this.mode == 1 && this.customizeCorpIds.includes(this.corpId); // 只在really，test_really，devtest2的云镜店中展示
  }

  mounted() {
		console.log('corpId', this.corpId);
    this.mode = +this.$route.params.mode;
    this.sgId = +this.$route.params.sgId;
    IPSService.getSiteStockInfo({
      postParams: {
        siteId: Number.parseInt(this.$route.params.siteId),
      },
    }).then((response) => {
      this.stockType = response.stockType;
      this.historyData = this.stockType;
      this.getGroupConfig();
    });
    if (!!this.isCustomizeVisible) {
      IPSService.getCustomizeInfo({
      postParams: {
        siteId: Number.parseInt(this.$route.params.siteId),
      },
    }).then((response) => {
      this.isCustomEnabled = !!response.isCustomize;
      this.historyCustomEnabled = this.isCustomEnabled;
      this.customizePrice = response.customizePrice === undefined || response.customizePrice === null ? null : Number(response.customizePrice);
      this.historyCustomizePrice = this.customizePrice;
    });
    }
  }

  /**
   * 获取网点组配置
   * @returns null
   */
  public getGroupConfig() {
    IPSService.getSiteGroupOtherConfig({
      postParams: {
        sgId: this.sgId,
      },
    }).then((response) => {
      this.stockTypeList[0].text = `小程序默认库存(${response.stockType === 1 ? '可提库存' : '可售库存'})`;
    });
  }

  /**
   * 切换库存
   * @param {number} val
   * @return null
   */
  public stockTypeChange(val) {
    this.$confirm(`是否将当前网点库存修改为${this.stockTypeList[val].text}`, { type: 'warning' }).then(
      (result) => {
        if (result === 'confirm') {
          this.stockType = val;
          this.historyData = val;
          this.onSave();
        }
      },
      () => {
        this.stockType = this.historyData;
      },
    );
  }

  /**
   * 保存可提/可售配置
   */
  public onSave() {
    IPSService.saveSiteStock({
      postParams: {
        siteId: Number.parseInt(this.$route.params.siteId),
        stockType: this.stockType,
      },
    }).then((response) => {
      if (response.result) {
        this.$message.success('保存成功');
      }
    });
  }

  /**
   * 保存定制功能配置
   */
  public onSaveCustomize() {
    if (this.isCustomEnabled && (this.customizePrice === null || this.customizePrice === undefined)) {
      this.$message.warning('请输入定制费');
      return;
    }
    this.isCustomizeSaving = true;
    IPSService.customizeInfoSave({
      postParams: {
        siteId: Number.parseInt(this.$route.params.siteId),
        isCustomize: this.isCustomEnabled ? 1 : 0,
        customizePrice: this.customizePrice,
      },
    }).then((response) => {
      if (response.result) {
        this.historyCustomEnabled = this.isCustomEnabled;
        this.historyCustomizePrice = this.customizePrice;
        this.$message.success('保存成功');
      } else {
        this.isCustomEnabled = this.historyCustomEnabled;
        this.customizePrice = this.historyCustomizePrice;
      }
      this.isCustomizeSaving = false;
    }, () => {
      this.isCustomEnabled = this.historyCustomEnabled;
      this.customizePrice = this.historyCustomizePrice;
      this.isCustomizeSaving = false;
    });
  }

  /**
   * 清除商品缓存
   * @param null
   * @return null
   */
  public clearCache() {
    if (!this.productCodes || !this.productCodes.trim()) {
      this.$message.warning('请输入货号');
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    IPSService.clearProductCodesCache({
      postParams: {
        siteId: Number.parseInt(this.$route.params.siteId),
        productCodes: this.productCodes.split(','),
      },
    })
      .then((result) => {
        loading.close();
        this.$message.success('缓存清除成功，请重新进入小程序查看');
      })
      .catch(() => {
        loading.close();
      });
  }

  render(h) {
    return (
      <div class="formWrapper">
        <el-form props={{ model: {} }} label-position="top" class="r-px-30 r-pt-2">
          <div class="formItemWrapper">
            <div class="blockTitle">网点库存取值配置</div>
            <el-form-item>
              <el-radio-group v-model={this.stockType} onChange={this.stockTypeChange.bind(this)}>
                {this.stockTypeList.map((v, i) => {
                  return (
                    <p key={i}>
                      <el-radio label={v.label}>{v.text}</el-radio>
                    </p>
                  );
                })}
              </el-radio-group>
            </el-form-item>
						{this.isCustomizeVisible && [
							<div class="blockTitle">定制功能</div>,
							<el-form-item style="margin-bottom: 0px !important;">
								<el-checkbox v-model={this.isCustomEnabled} disabled={this.isCustomizeSaving}>开启定制功能</el-checkbox>
							</el-form-item>,
              <el-form-item>
                <span>每位置定制费</span>
                <el-input-number
                  v-model={this.customizePrice}
                  controls={false}
                  disabled={!this.isCustomEnabled || this.isCustomizeSaving}
                  min={0}
                  max={99999999.99}
                  precision={2}
                  style="width: 80px;margin: 0 10px;"
                />
                <span>元</span>
                <el-button type="text" loading={this.isCustomizeSaving} onClick={this.onSaveCustomize.bind(this)} style="margin-left: 6px;text-decoration: underline;">
                  保存
                </el-button>
              </el-form-item>,
						]}
            {this.mode == 1 && [
              <div class="blockTitle">商品详情缓存清理</div>,
              <el-form-item>
                <el-input type="text" v-model={this.productCodes} placeholder="请输入商品货号，多个货号(最多30个)请用“,”分割" style="width: 480px">
                  <template slot="append">
                    <el-button type="primary" onClick={this.clearCache.bind(this)} style="border-radius: 0 4px 4px 0;border: 1px solid #5c8eff;">
                      清除缓存
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>,
            ]}
          </div>
        </el-form>
      </div>
    );
  }
}
